/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Faq_Alone_AInputs */

const en_price_page_faq_alone_a = /** @type {(inputs: Price_Page_Faq_Alone_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. You get your own adaptive plan with 3 free workouts, then 49 zł a month or 249 zł a year. You can add a coach whenever you like.`)
};

const pl_price_page_faq_alone_a = /** @type {(inputs: Price_Page_Faq_Alone_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tak. Dostajesz własny, dopasowujący się plan z 3 darmowymi treningami, potem 49 zł miesięcznie albo 249 zł rocznie. Trenera możesz dołączyć, kiedy zechcesz.`)
};

/**
* | output |
* | --- |
* | "Yes. You get your own adaptive plan with 3 free workouts, then 49 zł a month or 249 zł a year. You can add a coach whenever you like." |
*
* @param {Price_Page_Faq_Alone_AInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_faq_alone_a = /** @type {((inputs?: Price_Page_Faq_Alone_AInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Faq_Alone_AInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_faq_alone_a(inputs)
	return en_price_page_faq_alone_a(inputs)
});